import { render } from "./BoxMenu.vue?vue&type=template&id=407df8f5&scoped=true&ts=true"
import script from "./BoxMenu.vue?vue&type=script&lang=ts"
export * from "./BoxMenu.vue?vue&type=script&lang=ts"

import "./BoxMenu.vue?vue&type=style&index=0&id=407df8f5&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-407df8f5"]])

export default __exports__